import React from 'react'
import IconTwitter from '../icons/twitter.svg'
import IconFacebook from '../icons/facebook.svg'
import IconGooglePlus from '../icons/google-plus.svg'
import IconPinterest from '../icons/pinterest.svg'
import IconLinkedin from '../icons/linkedin.svg'

export default props => (
	<div className="share-wrap clearfix text-center">
		<div className="section-title h5">Share this article on:</div>
		<ul className="share-links">
			{/* <!-- twitter --> */}
			<li>
				<a
					href={`https://twitter.com/share?text=${props.title}&amp;url=${props.url}`}
					onClick={() => {
						window.open(this.href, 'twitter-share', 'width=580,height=296')
						return false
					}}
					className="twitter"
					title={`Share on Twitter`}
				>
					<IconTwitter /> Twitter
				</a>
			</li>
			{/* <!-- facebook --> */}
			<li>
				<a
					href={`https://www.facebook.com/sharer/sharer.php?u=${props.url}`}
					onClick={() => {
						window.open(this.href, 'facebook-share', 'width=580,height=296')
						return false
					}}
					className="facebook"
					title={`Share on Facebook`}
				>
					<IconFacebook /> Facebook
				</a>
			</li>
			{/* <!-- google plus --> */}
			<li>
				<a
					href={`https://plus.google.com/share?url=${props.url}`}
					onClick={() => {
						window.open(this.href, 'google-plus-share', 'width=580,height=296')
						return false
					}}
					className="google-plus"
					title={`Share on Google+`}
				>
					<IconGooglePlus /> Google+
				</a>
			</li>
			{/* <!-- pinterest --> */}
			<li>
				<a
					href={`http://pinterest.com/pin/create/button/?url=${props.url}&description=${props.title}`}
					onClick={() => {
						window.open(this.href, 'linkedin-share', 'width=580,height=296')
						return false
					}}
					className="pinterest"
					title={`Share on Pinterest`}
				>
					<IconPinterest /> Pinterest
				</a>
			</li>
			{/* <!-- linkedin --> */}
			<li>
				<a
					href={`http://www.linkedin.com/shareArticle?mini=true&url=${props.url}&title=${props.title}`}
					onClick={() => {
						window.open(this.href, 'linkedin-share', 'width=490,height=530')
						return false
					}}
					className="linkedin"
					title={`Share on Linkedin`}
				>
					<IconLinkedin /> Linkedin
				</a>
			</li>
		</ul>
	</div>
)
